import { render, staticRenderFns } from "./BasicInfoStep.vue?vue&type=template&id=38d12d02"
import script from "./BasicInfoStep.vue?vue&type=script&lang=js"
export * from "./BasicInfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports